import { FaSun, FaMoon } from "react-icons/fa";
import styles from "./DarkModeToggle.module.css";
import { useUser } from "../context/UserAttrContext"; // Import useUser for user context
import { useTheme } from "../hooks/useTheme";

const DarkModeToggle = () => {
    const { updateAttributes } = useUser(); // Destructure updateAttributes from user context
    const userToken = sessionStorage.getItem("token"); // Check if user is logged in
    const { darkMode, setDarkMode } = useTheme();

    const handleDarkModeToggle = () => {
        const nextDarkMode = !darkMode;
        if (userToken) {
            updateAttributes({ darkMode: nextDarkMode }); // Update darkMode attribute if logged in
        }
        setDarkMode(nextDarkMode);
    };

    return (
        <button
            onClick={handleDarkModeToggle}
            className={`${styles.toggleButton} ${darkMode ? styles.dark : styles.light}`}
        >
            {darkMode ? <FaSun className={styles.sunIcon} /> : <FaMoon className={styles.moonIcon} />}
        </button>
    );
};

export default DarkModeToggle;
